/**
 * all states from store
 */
export default {
  partner: {},
  parameters: {},
  customer_service: {},
  use_custom_logo: false,
  commission_percent: null,
};
